import { useState } from "react";
import { FiInfo } from "react-icons/fi";

import Typography from "@/components/Typography";

interface InfoTooltipProps {
  constructionAppreciation?: number;
  ipcaAppreciation?: number;
  initialInvestment?: number;
}

const InfoTooltip = ({
  constructionAppreciation = 0,
  ipcaAppreciation = 0,
  initialInvestment = 0,
}: InfoTooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  const formatValue = (value: number) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value / 100);
  };

  const totalAppreciation = constructionAppreciation + ipcaAppreciation;

  const constructionPercent =
    initialInvestment > 0
      ? ((constructionAppreciation / initialInvestment) * 100).toFixed(2)
      : "0.00";

  const ipcaPercent =
    initialInvestment > 0 ? ((ipcaAppreciation / initialInvestment) * 100).toFixed(2) : "0.00";

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        className="flex items-center"
        aria-label="Mostrar informações de valorização"
      >
        <FiInfo size={16} className="text-grey500 transition-colors hover:text-primary300" />
      </button>

      {isVisible && (
        <div className="absolute left-1/2 top-full z-50 mt-2 w-72 -translate-x-1/2 rounded-lg border border-grey200 bg-white p-4 shadow-lg">
          <div className="flex flex-col gap-3">
            <div className="flex items-center justify-between">
              <Typography variant="overline" color="grey500" className="text-xs uppercase">
                Valorização durante a construção
              </Typography>
              <div className="text-right">
                <Typography variant="pSmall" color="primary300" className="font-semibold">
                  +{formatValue(constructionAppreciation)}
                </Typography>
                <Typography variant="overline" color="grey500" className="text-xs">
                  ({constructionPercent}%)
                </Typography>
              </div>
            </div>
            <div className="h-px bg-grey100" />
            <div className="flex items-center justify-between">
              <Typography variant="overline" color="grey500" className="text-xs uppercase">
                IPCA acumulado
              </Typography>
              <div className="text-right">
                <Typography variant="pSmall" color="grey950" className="font-semibold">
                  +{formatValue(ipcaAppreciation)}
                </Typography>
                <Typography variant="overline" color="grey500" className="text-xs">
                  ({ipcaPercent}%)
                </Typography>
              </div>
            </div>
            <div className="h-px bg-grey200" />
            <div className="flex items-center justify-between">
              <Typography variant="overline" color="grey500" className="text-xs uppercase">
                Total valorizado
              </Typography>
              <div className="text-right">
                <Typography variant="pSmall" color="success300" className="font-semibold">
                  +{formatValue(totalAppreciation)}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;
